import { O2Button, O2Indent, O2InfoMessage, O2Section } from 'o2-theme-react';
import React, { FC, useEffect } from 'react';
import { I18n } from 'react-i18nify-lite';
import { connect } from 'react-redux';
import { RouteComponentProps, useLocation } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import queryString from 'query-string';

import { resendEmail } from '../../redux/actions/verificationActions';
import useAnalytics from '../../hooks/useAnalytics';
import StoreState from '../../redux/store/storeState';
import { Verification } from '../../redux/reducers/types';

interface StateProps {
  verification: Verification;
}

interface DispatchProps {
  resendEmail: (resendSecret: string, expired: boolean, email: string) => void;
}

interface IRegisterConfirmExpired extends RouteComponentProps, DispatchProps, StateProps {}
//SCR07
const RegisterConfirmExpired: FC<IRegisterConfirmExpired> = props => {
  const location = useLocation();
  const { token } = queryString.parse(location.search);
  const { pageLoaded } = useAnalytics();
  const [resendCounter, setResendCounter] = React.useState(0);
  const [isDisabled, setIsDisabled] = React.useState(false);

  useEffect(() => {
    pageLoaded('2.6.2.2', I18n.t('ume.ext.registerConfirmExpired.title'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const resendEmailHandler = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    setResendCounter(resendCounter + 1);
    setIsDisabled(true);
    if (resendCounter < 3) {
      setTimeout(() => {
        setIsDisabled(false);
      }, 90000);
    }
    props.resendEmail(token as string ?? '', true, (props.verification.emailType && props.verification.emailType?.email) ?? '');
  };

  return (
    <O2Section>
      <O2InfoMessage color="neutral">
        <O2Indent>
          <div className="o2-typo--heading-h6">{I18n.t('ume.ext.registerConfirmExpired.title')}</div>
        </O2Indent>
        <O2Indent>
          <O2Button
            color="primary"
            fullWidth="xs"
            disabled={isDisabled}
            onClick={resendEmailHandler}
          >
            {I18n.t('ume.ext.registerConfirmExpired.button')}
          </O2Button>
        </O2Indent>
      </O2InfoMessage>
    </O2Section>
  );
};

const mapStateToProps = (state: StoreState): StateProps => ({
  verification: state.verification
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>): DispatchProps => ({
  resendEmail: (resendSecret: string, expired: boolean, email: string) => dispatch(resendEmail(resendSecret, expired, email))
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterConfirmExpired);